import './FamilySupportStrip.scss';

import { faEnvelope } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const FamilySupportStrip = () => (
  <div className='fvt-family-support'>
    <p className='fvt-family-support__prompt mb-0'>Questions about the program?</p>
    <a href='mailto:support@myome.com' className='fvt-family-support__link'>
      <FontAwesomeIcon icon={faEnvelope} aria-hidden='true' />
      Contact Support
    </a>
  </div>
);
